import formMixins from "./formMixins"
import {mapActions} from "vuex"
import {EMPLOYEE, PARTNER} from '@/constants/usersTypes'


export default {
  mixins: [formMixins],
  data() {
    return {
      timerDurationS: 60,
      pendingSendPhone: false,
      pendingLogin: false,
      errorStatusCode: null,
      agree: false,
      shouldAutoSendPhone: false,
      isSent: false,
      showTimer: false,
      phoneValidation: null,
      sentCode: false,
      message: null,
    }
  },
  computed: {
    isPhoneCompleted() {
      return this.phoneValidation && this.phoneValidation.isValid
    },
    isPhoneSuccessButtonActive() {
      return this.isPhoneCompleted
          && (!this.isSent || !this.showTimer)
    },
    isLoginButtonActive() {
      return this.inputs.code.value && this.inputs.code.value.length >= 6
    },
    referralCode() {
      return this.$route.query.referal_code || getReferralFromLocalstorage()
    },
    agentReferralCode() {
      return this.$route.query.partner_referral_code || getAgentReferralFromLocalstorage()
    }
  },
  methods: {
    ...mapActions('user', [
      'getLoginConfirmationCode',
      'loginByPhoneAndCode',
    ]),
    sendPhone() {
      this.message = null
      this.resetErrorsMix(this.inputs)

      if(this.isRequiredEmptyMix) {
        return this.overallErrorsMix = this.$tAuth('All required fields must be filled')
      }

      if (!this.agree) {
        this.overallErrorsMix = this.$tAuth('Please agree rules')
        this.shouldAutoSendPhone = true
        return
      }

      const sendData = this.createSendDataMix(this.inputs)
      sendData.force = this.sentCode

      if (this.isRequiredEmptyMix) return;

      this.pendingSendPhone = true

      this.getLoginConfirmationCode({sendData}).then(({data}) => {
        this.isSent = true

        if (data.status === 'NOT_NEED_SEND') {
          this.showTimer = false
          this.message = data.message
          this.sentCode = true
        } else {
          this.showTimer = true
        }
      }).catch((error => {
        this.errorHandlerMix(error)
      })).finally(() => {
        this.pendingSendPhone = false
      })
    },
    onLogin() {
      this.message = null
      this.resetErrorsMix(this.inputs)
      this.pendingLogin = true

      const sendData = this.createSendDataMix(this.inputs)

      if(this.isPartner) {
        sendData.partner_referal_code = this.agentReferralCode
      }

      this.loginByPhoneAndCode({sendData, remember: true, isPartner: this.isPartner}).then(() => {
        return this.afterLogin()
      }).catch(this.errorHandlerMix).finally(() => {
        this.pendingLogin = false
      })
    },
    onAgreeChange(value) {
      this.agree = value

      if (value && this.shouldAutoSendPhone) {
        this.sendPhone()
      }

      this.onInput()
    },
    onInput(key) {
      this.shouldAutoSendPhone = false
      if (this.overallErrorsMix) {
        this.resetErrorsMix(this.inputs)
      }

      if (key === 'phone' && this.isSent) {
        this.isSent = false
        this.showTimer = false
      }
    },
    onTimerEnd() {
      this.showTimer = false
    },
    onClickRole(itemId) {
      this.inputs.user_type.value = itemId
    },
    afterLogin() {
      this.pendingLogin = true

      return this.$store.dispatch('user/loadUser').then((data) => {
        const userType = data.user.user_type
        const matchedRoute = this.$route.query.redirect ? this.$router.matcher.match(this.$route.query.redirect) : null

        if (
            matchedRoute
            && matchedRoute.name
        ) {
          if (
              !matchedRoute.meta.requiredUserTypes
              || !matchedRoute.meta.requiredUserTypes.length
              || matchedRoute.meta.requiredUserTypes.includes(userType)
          ) {
            return this.$router.push({path: this.$route.query.redirect})
          } else {
            const title = 'Для вашего аккаунта этот раздел закрыт'
            const message = userType === EMPLOYEE
                ? 'Вы авторизировались как соискатель. Для перехода в этот раздел вам нужно авторизировтся как роботодатель.'
                : 'Вы авторизировались как роботодатель. Для перехода в этот раздел вам нужно авторизировтся как соискатель.'
            this.$vModal.open('warning', {
              title,
              message
            })
          }
        }

        // if (this.previousPage && (this.previousPage.name !== 'home' && this.previousPage.name !== 'home-double')) {
        //   this.$router.push(this.previousPage.fullPath)
        // } else {
        if (data.user.user_type === EMPLOYEE) {
          this.$router.push({name: 'vacancies'})

          this.openChatBotPrimary()
        } else if (data.user.user_type === PARTNER) {
          this.$router.push({name: 'account-partner-partners-network'})
        } else {
          this.$router.push({name: 'account-vacancies'})
        }
        // }
      }).finally(() => {
        this.pendingLogin = false
      })
    },
    openChatBotPrimary() {
      if(!this.$store.state.user.resume && this.referralCode) {
        this.$vModal.open('after-respond-without-resume', {
          primary: true
        })
      }
    },
    onValidateTel(value) {
      this.phoneValidation = value
    }
  },
  created() {
    if(this.referralCode) {
      setReferralToLocalstorage(this.referralCode)
    }

    if(this.agentReferralCode) {
      setAgentReferralToLocalstorage(this.agentReferralCode)
    }
  }
}


function setReferralToLocalstorage(code) {
  window.localStorage.setItem('referralCode', code)
}

function getReferralFromLocalstorage() {
  return window.localStorage.getItem('referralCode')
}

function setAgentReferralToLocalstorage(code) {
  window.localStorage.setItem('agentReferralCode', code)
}

function getAgentReferralFromLocalstorage() {
  return window.localStorage.getItem('agentReferralCode')
}

export {setReferralToLocalstorage}
